var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.12 4.88086H3.5C2.94772 4.88086 2.5 5.32857 2.5 5.88086V16.5009C2.5 17.0531 2.94772 17.5009 3.5 17.5009H14.12C14.6723 17.5009 15.12 17.0531 15.12 16.5009V5.88086C15.12 5.32857 14.6723 4.88086 14.12 4.88086Z",
    stroke: "#4E4E4E",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 14.12V3.5C17.4999 2.95 17.0499 2.5 16.4999 2.5H5.87988",
    stroke: "#4E4E4E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.d1e66b1d3c7bf62ac1ed179a40d9838e.svg";
export { ForwardRef as ReactComponent };